import React, { useEffect, useState } from 'react';
import { usePermissions } from '../../../contexts/PermissionsContext';
import {
  addCustomerGroup,
  exportCustomerGroups,
  fetchCategories,
  fetchCustomerGroups,
  importCustomerGroups,
  updateCustomerGroups,
} from '../services/customersService';
import Pagination from '../../../components/Pagination';
import { showSuccessToast, showWarningToast } from '../../../utils/toastHelper';
import Loader from '../../../components/Loader';
import { useTranslation } from 'react-i18next';
// import ImportCustomersModal from "../components/ImportCustomersModal copy";
import AddCustomerGroupModal from '../components/AddCustomerGroupModal';
import EditCustomerGroupModal from '../components/EditCustomerGroupModal';
import ImportCustomersModal from '../components/ImportCustomersModal';
import { printTable } from '../../../utils/printUtils';
import FileNames from '../../../constants/fileNames';

export default function FBZCustomerGroup() {
  const { permissions } = usePermissions();
  const { t } = useTranslation('Customer');

  const [modalData, setModalData] = useState({});

  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isImportModalOpen, setImportModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  // const [selectAll, setSelectAll] = useState(false);
  const [selectedCustomerGroups, setSelectedCustomerGroups] = useState(
    new Set()
  );

  const [loading, setLoading] = useState(false);
  const [importLoading, setimportLoading] = useState(false);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [customerCategories, setCustomerCategories] = useState([]);
  const [customerCategory, setCustomerCategory] = useState({});

  // const [origins, setOrigins] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 20,
  });
  const [printLoading, setPrintLoading] = useState(false);

  const handleOpenModal = (modalType, customerGroup) => {
    setModalData(customerGroup);
    if (modalType === 'import') {
      setImportModalOpen(true);
    } else if (modalType === 'edit') {
      setEditModalOpen(true);
    } else if (modalType === 'add') {
      setAddModalOpen(true);
    }
  };
  const handleCloseModal = (modalType) => {
    if (modalType === 'import') {
      setImportModalOpen(false);
    } else if (modalType === 'add') {
      setAddModalOpen(false);
    } else if (modalType === 'edit') {
      setEditModalOpen(false);
    }
    setModalData({});
  };
  const handleCustomerGroupSelect = (e, id) => {
    const isChecked = e.target.checked;
    setSelectedCustomerGroups((prevSelected) => {
      const updatedSelection = new Set(prevSelected);
      if (isChecked) {
        updatedSelection.add(id);
      } else {
        updatedSelection.delete(id);
      }
      return updatedSelection;
    });
  };
  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allCustomerGroupIds = customerGroups.map(
        (customerGroup) => customerGroup.id
      );
      setSelectedCustomerGroups(new Set(allCustomerGroupIds));
    } else {
      setSelectedCustomerGroups(new Set());
    }
  };
  const isAllSelected =
    customerGroups.length > 0 &&
    customerGroups.every((customerGroup) =>
      selectedCustomerGroups.has(customerGroup.id)
    );

  const fetchData = async (page = 1, ifSearch = 0) => {
    setLoading(true);

    try {
      const per_page = 50;
      const query = { page, per_page, search: searchQuery, category: 'FBZ' };

      if (ifSearch) {
        const customerGroupResponse = await fetchCustomerGroups(query);

        if (customerGroupResponse.customer_groups) {
          setCustomerGroups(customerGroupResponse.customer_groups);
        }
        if (customerGroupResponse.pagination) {
          setPagination({
            total: customerGroupResponse.pagination.total,
            current_page: customerGroupResponse.pagination.current_page,
            last_page: customerGroupResponse.pagination.last_page,
            per_page: customerGroupResponse.pagination.per_page,
          });
        }
      } else {
        const [customerGroupResponse, categoriesResponse] = await Promise.all([
          fetchCustomerGroups(query),

          fetchCategories(),
        ]);

        if (customerGroupResponse.customer_groups) {
          setCustomerGroups(customerGroupResponse.customer_groups);
        }

        if (categoriesResponse.success) {
          setCustomerCategories(categoriesResponse.customer_categories);
          const cateringCategory = categoriesResponse.customer_categories.find(
            (category) => category.name.toLowerCase() === 'fbz'
          );
          setCustomerCategory(cateringCategory);
        }
        if (customerGroupResponse.pagination) {
          setPagination({
            total: customerGroupResponse.pagination.total,
            current_page: customerGroupResponse.pagination.current_page,
            last_page: customerGroupResponse.pagination.last_page,
            per_page: customerGroupResponse.pagination.per_page,
          });
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.current_page);
  }, [pagination.current_page]);
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(1, 1);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= pagination.last_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: pageNumber,
      }));
    }
  };
  const handleImportCustomerGroups = async (formData) => {
    setimportLoading(true);

    const response = await importCustomerGroups(formData);
    if (response.success) {
      setimportLoading(false);
      // handleCloseModal("import");
      fetchData();
      return response;
    }
    setimportLoading(false);
    return false;
  };
  const handleAddCustomerGroupSubmit = async (dataToSend) => {
    try {
      const response = await addCustomerGroup(dataToSend);
      if (response.success) {
        // setCustomers((prevCustomers) => prevCustomers.push(response.customer));
        fetchData(pagination.current_page);

        showSuccessToast(response.message);
        handleCloseModal('add');
      }
      return response;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleExportCustomerGroups = async () => {
    const data = {
      search: searchQuery,
      category: 'FBZ',
    };

    if (selectedCustomerGroups.size !== 0) {
      const selectedCustomerGroupsIds = Array.from(selectedCustomerGroups);

      data.selectedCustomerGroups = selectedCustomerGroupsIds;
    }
    const response = await exportCustomerGroups(
      data,
      FileNames.FBZ_CUSTOMER_GROUPS_EXPORT
    );
    // if (response.success) {
    //   showSuccessToast(response.message);
    // }
  };

  const handleEditCustomerGroupSubmit = async (dataToSend, customerGroupId) => {
    try {
      const response = await updateCustomerGroups(dataToSend, customerGroupId);
      if (response.success) {
        setCustomerGroups((prevCustomerGroup) =>
          prevCustomerGroup.map((customerGroup) =>
            customerGroup.id === customerGroupId
              ? response.customer_group
              : customerGroup
          )
        );
        // fetchData(pagination.current_page);

        showSuccessToast(response.message);
        handleCloseModal('edit');
      }
      return response;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handlePrint = () => {
    if (selectedCustomerGroups.size === 0) {
      showWarningToast(t('NOCUSTOMERGROUPSELECTED'));
      return;
    }

    const headers = [
      t('CUSTOMERCATEGORY'),
      t('CUSTOMERGROUP'),
      t('FULLNAME'),
      t('GROUPCODE'),
    ];

    const selectedCustomerGroupsData = customerGroups.filter((customerGroup) =>
      selectedCustomerGroups.has(customerGroup.id)
    );

    const content = selectedCustomerGroupsData.map((customerGroup) => [
      customerGroup.customer_category?.name || '',
      customerGroup.group || '',
      customerGroup.name || '',
      customerGroup.code || '',
    ]);

    printTable(headers, content, 'FBZ Customer Groups', setPrintLoading, true);
  };

  return (
    <main className="fbz-customer product-page fbz-container-set fbz-cus-cus-group">
      <section className="main-section">
        <section className="data">
          <div className="row">
            <div className="col-sm-6">
              <div className="left">
                <h1>{t('FBZCUSTOMERGROUP')}</h1>
                <div className="input-card">
                  <img src="images/search-icon.svg" alt="" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder={t('SEARCH')}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="right">
                <div className="filter-container">
                  <div className="button-group">
                    {permissions?.FBZ_CUSTOMER_GROUP_HOME_PAGE
                      ?.edit_permission === 1 && (
                      // <button>
                      //   <img src="images/import.svg" alt="" />
                      //   Import
                      // </button>
                      <button onClick={() => handleOpenModal('import', {})}>
                        <img src="images/import.svg" alt="" />
                        {t('IMPORT')}
                      </button>
                    )}
                    <button onClick={handleExportCustomerGroups}>
                      <img src="images/export.svg" alt="" />
                      {t('EXPORT')}
                    </button>
                    <button
                      className={`print ${selectedCustomerGroups.size === 0 ? 'disable-btn' : ''}`}
                      onClick={handlePrint}
                      disabled={
                        selectedCustomerGroups.size === 0 || printLoading
                      }
                    >
                      {printLoading ? (
                        <span>{t('PRINTING')}...</span>
                      ) : (
                        <>
                          <img src="images/print.svg" alt="" />
                          {t('PRINT')}
                        </>
                      )}
                    </button>
                    {permissions?.FBZ_CUSTOMER_GROUP_HOME_PAGE
                      ?.edit_permission === 1 && (
                      <button
                        className="add-btn"
                        onClick={() => handleOpenModal('add', '')}
                      >
                        + {t('ADD')}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="table-outer">
          <table className="table">
            <thead>
              <tr className="t-heading">
                <th className="t-checkbox">
                  <label className="container">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAllChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th className="category">
                  <h5>{t('CUSTOMERCATEGORY')}</h5>
                </th>
                <th className="location">
                  <h5>{t('CUSTOMERGROUP')}</h5>
                </th>
                <th className="origin">
                  <h5>{t('FULLNAME')}</h5>
                </th>

                <th className="origin">
                  <h5>{t('GROUPCODE')}</h5>
                </th>

                {permissions?.FBZ_CUSTOMER_GROUP_HOME_PAGE?.edit_permission ===
                  1 && (
                  <th className="action">
                    <h5>{t('ACTION')}</h5>
                  </th>
                )}
              </tr>
            </thead>
            {loading ? (
              <tr>
                <td colSpan="100%" className="loader-container mt-5">
                  <Loader />
                </td>
              </tr>
            ) : (
              <>
                <tbody>
                  {customerGroups.length === 0 ? (
                    <tr>
                      <td colSpan="100%" className="text-center py-4">
                        No record available.
                      </td>
                    </tr>
                  ) : (
                    customerGroups.map((customerGroup, index) => (
                      <tr>
                        <td className="t-checkbox">
                          <label className="container">
                            <input
                              type="checkbox"
                              checked={selectedCustomerGroups.has(
                                customerGroup.id
                              )}
                              onChange={(e) =>
                                handleCustomerGroupSelect(e, customerGroup.id)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td className="customer-category">
                          <h5>{customerGroup.customer_category?.name}</h5>
                        </td>
                        <td className="customer-group">
                          <h5>{customerGroup.group}</h5>
                        </td>
                        <td className="full-name">
                          <h5>{customerGroup.name}</h5>
                        </td>
                        <td className="group-code">
                          <h5>{customerGroup.code}</h5>
                        </td>

                        {permissions?.FBZ_CUSTOMER_GROUP_HOME_PAGE
                          ?.edit_permission === 1 && (
                          <td className="action">
                            <button
                              className="edit"
                              onClick={() =>
                                handleOpenModal('edit', customerGroup)
                              }
                            >
                              <img src="images/green-edit.svg" alt="" />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </>
            )}
          </table>
        </div>
        <Pagination
          currentPage={pagination.current_page}
          totalPages={pagination.last_page}
          paginate={paginate}
          loading={loading}
        />
        <AddCustomerGroupModal
          isOpen={isAddModalOpen}
          onClose={handleCloseModal}
          handleAddCustomerGroupSubmit={handleAddCustomerGroupSubmit}
          customerCategories={customerCategories}
          type="FBZ"
        />
        <EditCustomerGroupModal
          customerGroup={modalData}
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          handleEditCustomerGroupSubmit={handleEditCustomerGroupSubmit}
          customerCategories={customerCategories}
          type="FBZ"
        />
        <ImportCustomersModal
          isOpen={isImportModalOpen}
          onClose={handleCloseModal}
          handleImportCustomers={handleImportCustomerGroups}
          importLoading={importLoading}
          customerCategory={customerCategory}
          sample="customerGroups"
        />
      </section>
    </main>
  );
}
